import React from 'react';
import {Button} from "@mui/material";

const BaseSimpleItemEditorFooterButton = ({label, onClick, disabled, color}) => {
    return (
        <Button variant="contained" size="large" sx={{minWidth: "150px", textWrap: "nowrap"}} onClick={onClick} disabled={disabled} color={color}>
            {label}
        </Button>
    );
};

export default BaseSimpleItemEditorFooterButton;